@for (control of taellevaerker.controls; track control) {
  <div>
    <dff-form-control [formControl]="control.get('aflaesning.aktuel')"></dff-form-control>
  </div>
}
